<mat-card fxLayout="row wrap" fxLayoutAlign="space-around" class="default-contact">
    <div fxFlex fxLayout="row wrap" fxLayoutAlign="space-around" *ngIf="!!storeDetails">
      <div fxFlex="100" fxFlex.gt-xs="33.3">
          <div fxLayout="column" fxLayoutAlign="center center" class="text-center">
              <i class="material-icons md-36 primary-clr" data-icon="home"></i> 
              <h3 class="primary-text py-1">AREA WE SERVICE :</h3>
              <span class="text-muted">
                {{storeDetails.address}}
              </span>
          </div>
      </div>
      <div fxFlex="100" fxFlex.gt-xs="33.3" ngClass.xs="mt-2">
          <div fxLayout="column" fxLayoutAlign="center center">
              <i class="material-icons md-36 primary-clr" data-icon="call"></i> 
              <h3 class="primary-text py-1">PHONES :</h3>
              <span class="text-muted">{{storeDetails.phone | phone: 'US'}}</span>
          </div>
      </div>
      <div fxFlex="100" fxFlex.gt-xs="33.3" ngClass.xs="mt-2">
          <div fxLayout="column" fxLayoutAlign="center center">
              <i class="material-icons md-36 mat-icon-lg primary-clr"  data-icon="mail_outline"></i>
              <h3 class="primary-text py-1">E-MAIL :</h3>
              <!-- <span class="text-muted">{{storeDetails.reply_to_email}}</span> -->
              <span class="text-muted"> {{storeDetails.reply_to_email}}</span>
          </div>
      </div>
      <!-- <div class="divider w-100 mt-2"></div> -->
    </div>
      <!-- <h3 class="w-100 text-center py-2">CONTACT US</h3> -->
      
      <!-- <form [formGroup]="contactForm" (ngSubmit)="onContactFormSubmit(contactForm.value)" fxLayout="row wrap">
          <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1" ngClass.sm="mt-1" ngClass.xs="mt-1">
            <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Name</mat-label>
                  <input matInput placeholder="Name" formControlName="name" required>
                  <mat-error *ngIf="contactForm.controls.name.errors?.required">Name is required</mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1" ngClass.sm="mt-1" ngClass.xs="mt-1">
            <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Email</mat-label>
                  <input matInput placeholder="Email" formControlName="email" required>
                  <mat-error *ngIf="contactForm.controls.email.errors?.required">Email is required</mat-error>
                  <mat-error *ngIf="contactForm.controls.email.hasError('invalidEmail')">Invalid email address</mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1" ngClass.sm="mt-1" ngClass.xs="mt-1">
            <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Phone</mat-label>
                  <input matInput placeholder="Phone" formControlName="phone" required>
                  <mat-error *ngIf="contactForm.controls.phone.errors?.required">Phone is required</mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="100" class="px-1 mt-1">
            <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Message</mat-label> 
                  <textarea matInput placeholder="Message" formControlName="message" required rows="7"></textarea> 
                  <mat-error *ngIf="contactForm.controls.message.errors?.required">Message is required</mat-error>
            </mat-form-field>
          </div> 
          <div class="w-100 py-2 text-center">
            <button mat-raised-button color="primary" type="submit">Submit</button>
          </div> 
      </form> -->
  
  </mat-card>